/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const ainvoice_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.5 6.5V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646V22a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1v-2.5"
    />
    <path
      fill="#000"
      d="M7.472 15.224c0 .203.043.352.128.448.096.085.245.128.448.128L8.032 17c-.192.096-.437.144-.736.144-.405 0-.747-.107-1.024-.32a1.438 1.438 0 0 1-.512-.864 2.96 2.96 0 0 1-1.072.864c-.437.213-.901.32-1.392.32-.81 0-1.461-.208-1.952-.624-.49-.427-.736-.987-.736-1.68 0-.715.235-1.28.704-1.696.47-.416 1.2-.704 2.192-.864l2.096-.32v-.176c0-.437-.139-.784-.416-1.04-.267-.256-.667-.384-1.2-.384-.437 0-.784.09-1.04.272a1.679 1.679 0 0 0-.56.768l-1.472-.752c.235-.587.608-1.03 1.12-1.328.512-.31 1.195-.464 2.048-.464 1.11 0 1.952.267 2.528.8.576.533.864 1.275.864 2.224v3.344Zm-3.84.48c.608 0 1.088-.192 1.44-.576.352-.395.528-.933.528-1.616v-.224l-1.616.256c-.533.085-.923.23-1.168.432-.235.192-.352.459-.352.8 0 .277.101.501.304.672.213.17.501.256.864.256Z"
    />
  </svg>
)
export default ainvoice_medium
